import { render, staticRenderFns } from "./VideoConsent.vue?vue&type=template&id=d12ab3d4&scoped=true&"
import script from "./VideoConsent.vue?vue&type=script&lang=js&"
export * from "./VideoConsent.vue?vue&type=script&lang=js&"
import style0 from "./VideoConsent.vue?vue&type=style&index=0&id=d12ab3d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12ab3d4",
  null
  
)

export default component.exports